import { Channel } from '@ibe/services';

export const dealFinderOpenDatePickerEvent = new Channel<Object>(
  Object,
  'deal-finder-open-date-picker-event'
);
